import {
  PROTOTYPE_STENCIL_SLUG,
  TOP_SIDE,
  STENCIL_TOP_SIDE,
  basicStencils,
} from 'shared/product_tabs/tab_stencils/data/constants';

export const deleteStencilsFromCart = (state, calledFromCart = false) => {
  const idDestroy = state.stencils.filter((s) => s.line_item_id !== undefined).map((s) => s.line_item_id);

  if (idDestroy.length) {
    state.stencilsToDestroy.push(...idDestroy);
  }
  state.stencilsToDestroy = [...new Set(state.stencilsToDestroy)];

  if (calledFromCart) {
    state.stencilsParameters = {};
    state.stencils = [];
    state.stencilsToBuy = [];
    state.stencilsSide = null;

    state.stencilsType = PROTOTYPE_STENCIL_SLUG;
    state.stencilsSide = TOP_SIDE;

    const stencil = _.cloneDeep(basicStencils);
    stencil.product = Spree.stencils_info.find((s) => s.slug === PROTOTYPE_STENCIL_SLUG);
    stencil.parameters.stencil_side = STENCIL_TOP_SIDE;
    state.stencils.push(stencil);
  }
};
